import type { UUID } from '@/types/Id'
import type { IntegrationProvider } from '@/types/Integration'

interface IntegrationsQueryKeyArgs {
  orgId: UUID | ''
}

interface IntegrationQueryKeyArgs {
  integrationId: UUID | ''
}

interface IntegrationSyncStatusQueryKeyArgs {
  orgId: UUID | ''
  provider: IntegrationProvider
}

export const integrationsQueryKeys = {
  all: () => ['integrations'] as const,
  organization: (keyArgs: IntegrationsQueryKeyArgs) =>
    ['integrations', keyArgs.orgId] as const,
  integration: (keyArgs: IntegrationQueryKeyArgs) =>
    ['integration', keyArgs.integrationId] as const,
  orgSyncStatus: (keyArgs: IntegrationSyncStatusQueryKeyArgs) =>
    ['integration_sync_status', keyArgs.orgId, keyArgs.provider] as const,
}

export const integrationsMutationKeys = {
  syncStart: (keyArgs: IntegrationSyncStatusQueryKeyArgs) =>
    ['integration_sync_start', keyArgs.orgId, keyArgs.provider] as const,
  update: (keyArgs: IntegrationQueryKeyArgs) =>
    ['integration_update', keyArgs.integrationId] as const,
  delete: (keyArgs: IntegrationQueryKeyArgs) =>
    ['integration_delete', keyArgs.integrationId] as const,
}

export interface IntegrationTokenResponse {
  token: string
  expires_at: string
}

interface IntegrationTokenQueryKeyArgs {
  orgId: UUID | ''
  providers: IntegrationProvider[]
}

export const integrationTokenQueryKeys = {
  all: () => ['integration_token'] as const,
  organization: (keyArgs: IntegrationTokenQueryKeyArgs) =>
    ['integration_token', keyArgs.orgId, ...keyArgs.providers.sort()] as const,
}
